'use client';

import { useEffect } from 'react';
import { useChatInstancesStore } from '../store/chatInstancesStore';
import { useLayoutStore } from '../store/layoutStore';
import { openCopilotPanel } from './useMentions';

export function useDetachedWindowLifecycle(): void {
  useEffect(() => {
    if (!window.electronAPI?.detachedWindows) {
      return;
    }

    const cleanupClosed = window.electronAPI.detachedWindows.onDetachedClosed(
      ({ kind, id }) => {
        if (kind === 'tab') {
          useLayoutStore.getState().markTabReattached(id);

          return;
        }

        useChatInstancesStore.getState().discardInMemoryChats();
        useLayoutStore.getState().markCopilotReattached();
        openCopilotPanel();
      },
    );

    return cleanupClosed;
  }, []);
}
